<template>
  <v-container class="cliente-auth-container">
    <v-row justify="center">
      <v-col
        cols="12"
        sm="10"
        md="7"
        lg="5"
      >
        <v-card class="pa-5" elevation="2">
          <v-card-title
            class="justify-center text-h5 font-weight-bold"
          >
            Crear cuenta
          </v-card-title>

          <v-card-subtitle class="text-center">
            Completá tus datos para registrarte.
          </v-card-subtitle>

          <v-card-text>
            <v-alert
              v-if="mensajeError"
              type="error"
              text
              dismissible
              class="mb-4"
              @input="mensajeError = ''"
            >
              {{ mensajeError }}
            </v-alert>

            <v-form
              ref="formRegistro"
              v-model="formularioValido"
              lazy-validation
              @submit.prevent="registrar"
            >
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model.trim="form.nombre"
                    label="Nombre"
                    autocomplete="given-name"
                    :rules="reglasNombre"
                    :error-messages="errores.nombre"
                    outlined
                    required
                    @input="limpiarError('nombre')"
                  />
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model.trim="form.apellido"
                    label="Apellido"
                    autocomplete="family-name"
                    :rules="reglasApellido"
                    :error-messages="errores.apellido"
                    outlined
                    required
                    @input="limpiarError('apellido')"
                  />
                </v-col>
              </v-row>

              <v-text-field
                v-model.trim="form.email"
                label="Correo electrónico"
                type="email"
                autocomplete="email"
                :rules="reglasEmail"
                :error-messages="errores.email"
                outlined
                required
                @input="limpiarError('email')"
              />

              <v-text-field
                v-model.trim="form.whatsapp"
                label="WhatsApp"
                type="tel"
                autocomplete="tel"
                :error-messages="errores.whatsapp"
                outlined
                @input="limpiarError('whatsapp')"
              />

              <v-text-field
                v-model="form.password"
                label="Contraseña"
                :type="mostrarPassword ? 'text' : 'password'"
                :append-icon="
                  mostrarPassword
                    ? 'mdi-eye-off'
                    : 'mdi-eye'
                "
                autocomplete="new-password"
                :rules="reglasPassword"
                :error-messages="errores.password"
                outlined
                required
                @click:append="
                  mostrarPassword = !mostrarPassword
                "
                @input="limpiarError('password')"
              />

              <v-text-field
                v-model="form.password_confirmation"
                label="Repetir contraseña"
                :type="
                  mostrarConfirmacion
                    ? 'text'
                    : 'password'
                "
                :append-icon="
                  mostrarConfirmacion
                    ? 'mdi-eye-off'
                    : 'mdi-eye'
                "
                autocomplete="new-password"
                :rules="reglasConfirmacion"
                outlined
                required
                @click:append="
                  mostrarConfirmacion =
                    !mostrarConfirmacion
                "
              />

              <v-btn
                type="submit"
                color="primary"
                block
                large
                :loading="cargando"
                :disabled="cargando"
              >
                Crear cuenta
              </v-btn>
            </v-form>

            <div class="d-flex align-center my-5">
              <v-divider />

              <span class="mx-3 grey--text">
                o
              </span>

              <v-divider />
            </div>

            <v-btn
              block
              large
              outlined
              :disabled="cargando"
              @click="continuarConGoogle"
            >
              <v-icon left>
                mdi-google
              </v-icon>

              Continuar con Google
            </v-btn>
          </v-card-text>

          <v-divider />

          <v-card-actions class="justify-center pt-5">
            <span class="mr-2">
              ¿Ya tenés una cuenta?
            </span>

            <router-link to="/login">
              Iniciar sesión
            </router-link>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClienteAuthService from "../service/ClienteAuthService";

export default {
  name: "ClienteRegistroView",

  data() {
    return {
      formularioValido: false,
      cargando: false,
      mostrarPassword: false,
      mostrarConfirmacion: false,
      mensajeError: "",
      errores: {},

      form: {
        nombre: "",
        apellido: "",
        email: "",
        whatsapp: "",
        password: "",
        password_confirmation: "",
      },

      reglasNombre: [
        (value) =>
          !!value || "El nombre es obligatorio.",
      ],

      reglasApellido: [
        (value) =>
          !!value || "El apellido es obligatorio.",
      ],

      reglasEmail: [
        (value) =>
          !!value ||
          "El correo electrónico es obligatorio.",

        (value) =>
          /.+@.+\..+/.test(value) ||
          "Ingresá un correo electrónico válido.",
      ],

      reglasPassword: [
        (value) =>
          !!value ||
          "La contraseña es obligatoria.",

        (value) =>
          !value ||
          value.length >= 8 ||
          "La contraseña debe tener al menos 8 caracteres.",
      ],
    };
  },

  computed: {
    reglasConfirmacion() {
      return [
        (value) =>
          !!value ||
          "Repetí la contraseña.",

        (value) =>
          value === this.form.password ||
          "Las contraseñas no coinciden.",
      ];
    },
  },

  mounted() {
    const token = localStorage.getItem(
      "cliente_token"
    );

    if (token) {
      this.$router.replace({
        name: "cliente-perfil",
      });
    }
  },

  methods: {

    continuarConGoogle() {
      localStorage.setItem(
        "google_redirect_after_login",
        "/checkout"
      );

      ClienteAuthService.loginConGoogle();
    },
    
    limpiarError(campo) {
      if (this.errores[campo]) {
        this.$delete(this.errores, campo);
      }

      this.mensajeError = "";
    },

    async registrar() {
      this.mensajeError = "";
      this.errores = {};

      const esValido =
        this.$refs.formRegistro.validate();

      if (!esValido) {
        return;
      }

      this.cargando = true;

      try {
        const respuesta =
          await ClienteAuthService.registrar({
            nombre: this.form.nombre.trim(),
            apellido: this.form.apellido.trim(),

            email: this.form.email
              .trim()
              .toLowerCase(),

            whatsapp:
              this.form.whatsapp.trim() || null,

            password: this.form.password,

            password_confirmation:
              this.form.password_confirmation,
          });

        const { access_token, cliente } =
          respuesta.data;

        if (!access_token || !cliente) {
          throw new Error(
            "La respuesta del servidor es inválida."
          );
        }

        localStorage.setItem(
          "cliente_token",
          access_token
        );

        localStorage.setItem(
          "cliente_data",
          JSON.stringify(cliente)
        );

        this.$router.replace({
            name: "Checkout",
        });
      } catch (error) {
        const respuesta = error.response;

        if (respuesta && respuesta.status === 422) {
          this.errores =
            respuesta.data.errors || {};

          this.mensajeError =
            "Revisá los datos ingresados.";

          return;
        }

        this.mensajeError =
          "No pudimos crear la cuenta. Intentá nuevamente.";
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>

<style scoped>
.cliente-auth-container {
  padding-top: 48px;
  padding-bottom: 48px;
}
</style>